import React from 'react';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Title at the very top */}
      <div className="hero-title-top">
        <h1 className="animated-title"><span className="purple-gradient-text">Learn Smart not Hard</span></h1>
        <p className="hero-subtitle">Transform any YouTube video into an interactive  AI-powered course with personalized learning paths.</p>
      </div>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          {/* Landing Video */}
          <div className="hero-video-container">
            <video 
              className="hero-landing-video"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/full_video_coursiva.mp4" type="video/mp4" />
              <source src="/full_video_coursiva.mp4" type="video/quicktime" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>

      {/* Features Section - Duolingo Style */}
      <div className="features-section">
        <div className="features-container">
          
          {/* Feature 1: Text Left, Video Right */}
          <div className="feature-row">
            <div className="feature-content">
              <h2><span className="gradient-text">Youtube lecture summary and transcript</span></h2>
              <p>
                Simply paste any YouTube video URL and our AI instantly creates 
                an interactive course with mind maps, key concepts, and learning paths 
                tailored to your pace.
              </p>
            </div>
            <div className="feature-video">
              <video 
                className="feature-demo-video"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="/summary_coursiva.mp4" type="video/mp4" />
                <source src="/summary_coursiva.mp4" type="video/quicktime" />
              </video>
            </div>
          </div>

          {/* Feature 2: Video Left, Text Right */}
          <div className="feature-row">
            <div className="feature-video">
              <video 
                className="feature-demo-video"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="/flashcards_coursiva.mp4" type="video/mp4" />
                <source src="/flashcards_coursiva.mp4" type="video/quicktime" />
              </video>
            </div>
            <div className="feature-content">
              <h2><span className="gradient-text">Flashcards</span></h2>
              <p>
              Strengthen your memory using spaced repetition and interactive flashcard sessions tailored to your performance.
               Each flashcard adapts to how well you know the material — ensuring efficient, personalized learning.
              </p>
            </div>
          </div>

          {/* Feature 3: Text Left, Video Right */}
          <div className="feature-row">
            <div className="feature-content">
              <h2><span className="gradient-text">Mind Maps</span></h2>
              <p>
                Visualize complex topics with mind maps. 
                Navigate through concepts intuitively and see how ideas connect 
                to build deeper understanding.
              </p>
            </div>
            <div className="feature-video">
              <video 
                className="feature-demo-video"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="/flashcards_coursiva.mp4" type="video/mp4" />
                <source src="/flashcards_coursiva.mp4" type="video/quicktime" />
              </video>
            </div>
          </div>

          {/* Feature 4: Video Left, Text Right */}
          <div className="feature-row">
            <div className="feature-video">
              <video 
                className="feature-demo-video"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="/quizz_coursiva.mp4" type="video/mp4" />
                <source src="/quizz_coursiva.mp4" type="video/quicktime" />
              </video>
            </div>
            <div className="feature-content">
              <h2><span className="gradient-text">Quizzes</span></h2>
              <p>
                Test your knowledge with quizzes. Reinforce learning through spaced repetition and adaptive 
                question difficulty based on your performance.
              </p>
            </div>
          </div>

          {/* Feature 5: Text Left, Video Right */}
          <div className="feature-row">
            <div className="feature-content">
              <h2><span className="gradient-text">AI Tutor</span></h2>
              <p>
                Ask any question about the YouTube video content and get instant, personalized answers. 
                Our AI tutor understands the context and provides detailed explanations to help you 
                master difficult concepts.
              </p>
            </div>
            <div className="feature-video">
              <video 
                className="feature-demo-video"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="/ai_tutor_coursiva.mp4" type="video/mp4" />
                <source src="/ai_tutor_coursiva.mp4" type="video/quicktime" />
              </video>
            </div>
          </div>

        </div>
      </div>



      {/* Footer */}
      <footer className="footer-section">
        <div className="footer-container">
          <p>&copy; 2025 Coursiva. Built with ❤️ for learners.</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 